import React from 'react';
import CollectionPage from '../shared/CollectionPage';

/**
 * Game Wishlist Dashboard component
 * Uses the generic CollectionPage with game-specific configuration for wishlist
 */
const GameWishlistDashboard = () => {
  // Game-specific filter options
  const gameFilterOptions = [
    { value: 'PlayStation 5', label: 'PlayStation 5' },
    { value: 'PlayStation 4', label: 'PlayStation 4' },
    { value: 'PlayStation 3', label: 'PlayStation 3' },
    { value: 'PlayStation 2', label: 'PlayStation 2' },
    { value: 'PlayStation', label: 'PlayStation' },
    { value: 'Xbox Series X', label: 'Xbox Series X' },
    { value: 'Xbox One', label: 'Xbox One' },
    { value: 'Xbox 360', label: 'Xbox 360' },
    { value: 'Xbox', label: 'Xbox' },
    { value: 'Nintendo Switch', label: 'Nintendo Switch' },
    { value: 'Wii U', label: 'Wii U' },
    { value: 'Wii', label: 'Wii' },
    { value: 'GameCube', label: 'GameCube' },
    { value: 'Nintendo 64', label: 'Nintendo 64' },
    { value: 'PC', label: 'PC' }
  ];

  // Game-specific render props
  const gameRenderProps = {
    getItemSubtitle: (item) => `Platform: ${item.platform} • Priority: ${item.priority || 'Medium'}`,
    getItemDetails: (item) => item.summary
      ? (item.summary.length > 100 ? `${item.summary.substring(0, 100)}...` : item.summary)
      : null,
    isWishlist: true
  };

  // Game-specific filter function
  const getGameFilterValue = (item) => item.platform;

  // Game-specific edit fields
  const gameEditFields = [
    {
      name: 'name',
      label: 'Game Title',
      type: 'text',
      required: true,
      gridProps: { xs: 12 }
    },
    {
      name: 'platform',
      label: 'Platform',
      type: 'text',
      required: true,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'priority',
      label: 'Priority',
      type: 'select',
      options: ['Low', 'Medium', 'High'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'imageUrl',
      label: 'Image URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'summary',
      label: 'Summary',
      type: 'text',
      multiline: true,
      rows: 4,
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'rating',
      label: 'Rating',
      type: 'rating',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'notes',
      label: 'Notes',
      type: 'text',
      multiline: true,
      rows: 4,
      required: false,
      gridProps: { xs: 12 }
    }
  ];

  return (
    <CollectionPage
      collectionType="game-wishlist"
      title="Game Wishlist"
      isWishlist={true}
      itemType="game"
      renderProps={gameRenderProps}
      filterOptions={gameFilterOptions}
      getFilterValue={getGameFilterValue}
      editFields={gameEditFields}
    />
  );
};

export default GameWishlistDashboard;
